module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"-5.5 24.5 12 12\" enable-background=\"new -5.5 24.5 12 12\"><path d=\"M5 28.1l-3.3-3.6h-4.8c-.5 0-1 .4-1 1v10c0 .5.4 1 .9 1h7.2c.5 0 1-.4 1-1v-7.4zm-2.1 6h-4.8c-.1 0-.3-.1-.3-.3 0-.1.1-.3.3-.3h4.8c.1 0 .3.1.3.3-.1.2-.2.3-.3.3zm0-1.9h-4.8c-.1 0-.3-.1-.3-.3 0-.1.1-.3.3-.3h4.8c.1 0 .3.1.3.3-.1.2-.2.3-.3.3zm0-1.9h-4.8c-.1 0-.3-.1-.3-.3 0-.1.1-.3.3-.3h4.8c.1 0 .3.1.3.3-.1.2-.2.3-.3.3z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/hti-document.svg
// module id = 798
// module chunks = 1